import { createSlice } from '@reduxjs/toolkit';
const initState: any = {
  isAuth: false,
  profileData: {},
  isExpiredToken: false,
  isExpiredPassword: false,
  isForceLogout: false,
  permissionCheckObj: {},
  registerData: {},
  otpVerifiedEmail: null,
  accountId: 0,
  employeeId: '',
  showEmail: '',
  getLayoutCollapsed: false,
  isMenuClicked: false,
  commonRefreshObj: {},
  allEmpListRefetch:{},
  tokenData: {},
  refreshMenu: false,
  // Impersonation state. When acting as another account:
  //   profileData.token + profileData.tokenData hold the impersonated values
  //   originalToken + originalTokenData hold the real user's stashed values
  // When not impersonating, originalToken / originalTokenData / impersonatedAccount are null.
  originalToken: null,
  originalTokenData: null,
  impersonatedAccount: null,

};


export const authSlice = createSlice({
  name: 'auth',
  initialState: initState,
  reducers: {
    setLogin: (state, action) => {
      const { payload } = action;
      state.isAuth = true;
      state.profileData = {
        ...state.profileData,
        ...payload,
      };
    },
    setLogout: () => {
      return initState;
    },
    setFeaturePermissionCheck: (state, action) => {
      const { payload } = action;
      state.permissionCheckObj = payload;
    },
    setShowEmail: (state, action) => {
      state.profileData = {
        ...state.profileData,
        optEmail: action.payload,
      };
    },
    setOtpVerifiedEmail: (state, action) => {
      state.profileData = {
        ...state.profileData,
        otpVerifiedEmail: action.payload,
      };
    },
    setTokenData: (state, action) => {
      // console.log('slice :', action.payload);
      state.profileData = {
        ...state.profileData,
        tokenData: action.payload,
      };
    },
    setRefreshMenu: (state, action) => {
      // console.log("from slice, refresh bool =",action.payload)
      state.refreshMenu = action.payload;
    },
    setEmployeeId: (state, action) => {
      state.employeeId = action.payload
    },
    setLayoutCollapsed: (state, action) => {
      state.profileData = {
        ...state.profileData,
        getLayoutCollapsed: action.payload
      };

    },
    setIsMenuClicked: (state, action) => {
      state.isMenuClicked = action.payload
    },
    setCommonRefreshObj: (state, action) => {
      state.commonRefreshObj = action.payload
    },
    setAllEmpListRefetch: (state, action) => {
      state.allEmpListRefetch = action.payload
    },
    setSignupContext: (state, action) => {
      state.profileData = {
        ...state.profileData,
        signupContext: {
          ...(state.profileData?.signupContext || {}),
          ...action.payload,
        },
      };
    },
    setImpersonation: (state, action) => {
      const { token, tokenData, account } = action.payload || {};
      if (!token) return;
      // Stash the real login's token/tokenData on first impersonation only,
      // so chained "act as" jumps don't lose the original.
      if (!state.originalToken) {
        state.originalToken = state.profileData?.token ?? null;
        state.originalTokenData = state.profileData?.tokenData ?? null;
      }
      state.profileData = {
        ...state.profileData,
        token,
        tokenData: tokenData ?? state.profileData?.tokenData,
      };
      state.impersonatedAccount = account ?? null;
    },
    clearImpersonation: (state) => {
      if (state.originalToken) {
        state.profileData = {
          ...state.profileData,
          token: state.originalToken,
          tokenData: state.originalTokenData ?? state.profileData?.tokenData,
        };
      }
      state.originalToken = null;
      state.originalTokenData = null;
      state.impersonatedAccount = null;
    },

  },
});
